
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/historical-snowfall",
      function () {
        return require("private-next-pages/[region]/[resort]/historical-snowfall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/historical-snowfall"])
      });
    }
  